<script>
  export let title;
  export let onClick;
</script>

<div on:click={onClick}>
  <span>{title}</span>
</div>

<style>
  div {
    background-color: white;
    height: 60px;
    max-width: 480px;
    width: 95%;
    border-radius: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    box-shadow: 3px 5px 3px 0 rgba(59, 73, 70, 0.22);
    font-family: "Open Sans", sans-serif;
    color: #aaa;
    font-size: 18px;
    font-weight: 600;
    letter-spacing: 1px;
    text-align: center;
  }

  div:not(:first-child) {
    margin-top: 50px;
  }

  div:hover {
    opacity: 0.8;
    transition: opacity 0.5s;
  }
</style>
